<template>
  <h2 class="font-serif pt-5 text-xl sm:text-2xl italic tracking-tight text-gray-900 dark:text-white">
    <slot/>
  </h2>
</template>
